export default {
  title: 'EMP后台',
  loginPageName: '登录',
  logoutTip: '退出系统, 是否继续?',
  submitText: '确定',
  cancelText: '取消',
  search: '请输入搜索内容',
  menuTip: '没有发现菜单',
  common: {
    condition: '条件',
    display: '显示',
    hide: '隐藏',
  },
  tip: {
    select: '请选择',
    input: '请输入',
  },
  upload: {
    upload: '点击上传',
    tip: '将文件拖到此处，或',
  },
  date: {
    start: '开始日期',
    end: '结束日期',
    t: '今日',
    y: '昨日',
    n: '近7天',
    a: '全部',
  },
  form: {
    printBtn: '打 印',
    mockBtn: '模 拟',
    submitBtn: '提 交',
    emptyBtn: '清 空',
    addSub: '新增子项',
  },
  crud: {
    filter: {
      addBtn: '新增条件',
      clearBtn: '清空数据',
      resetBtn: '清空条件',
      cancelBtn: '取 消',
      submitBtn: '确 定',
    },
    column: {
      name: '列名',
      hide: '隐藏',
      fixed: '冻结',
      filters: '过滤',
      sortable: '排序',
      index: '顺序',
      width: '宽度',
    },
    tipStartTitle: '当前表格已选择',
    tipEndTitle: '项',
    editTitle: '编 辑',
    copyTitle: '复 制',
    addTitle: '新 增',
    viewTitle: '查 看',
    filterTitle: '过滤条件',
    showTitle: '列显隐',
    menu: '操作',
    addBtn: '新 增',
    addSub: '新增子项',
    show: '显 示',
    hide: '隐 藏',
    open: '展 开',
    shrink: '收 缩',
    printBtn: '打 印',
    excelBtn: '导 出',
    updateBtn: '修 改',
    cancelBtn: '取 消',
    searchBtn: '搜 索',
    emptyBtn: '清 空',
    menuBtn: '功 能',
    saveBtn: '保 存',
    viewBtn: '查 看',
    editBtn: '编 辑',
    copyBtn: '复 制',
    delBtn: '删 除',
  },
  login: {
    loginHeader: '登录',
    loginAcc: '账号',
    loginAcctx: '请输入账号名称',
    loginPass: '密码',
    loginPasstx: '请输入密码',
    loginCode: '请输入验证码',
    loginCodetx: '请输入验证码',
    loginButton: '登录',
    loginWait: '登录中，请稍后',
    ces: 'CSE',
    emp: 'EMP',
    basicLoding: '系统加载中',
    basictxLoading: 'CSE EMP 系统加载中',
    title: '登录 ',
    account: '账号',
    haveAccount: '还没有账号？',
    info: 'BladeX 企业级开发平台',
    tenantId: '租户',
    username: '用户名',
    password: '密码',
    wechat: '微信',
    qq: 'QQ',
    github: 'github',
    gitee: '码云',
    phone: '请输入手机号',
    code: '请输入验证码',
    submit: '登录',
    register: '注册',
    userLogin: '账号密码登录',
    phoneLogin: '手机号登录',
    thirdLogin: '第三方登录',
    ssoLogin: '单点登录',
    msgText: '发送验证码',
    msgSuccess: '秒后重发',
  },
  navbar: {
    info: '信息',
    logOut: '退出登录',
    userinfo: '个人信息',
    switchDept: '部门切换',
    dashboard: '首页',
    lock: '锁屏',
    bug: '没有错误日志',
    bugs: '条错误日志',
    screenfullF: '退出全屏',
    screenfull: '全屏',
    language: '中英文',
    notice: '消息通知',
    theme: '主题',
    color: '换色',
  },
  tagsView: {
    search: '搜索',
    menu: '更多',
    clearCache: '清除缓存',
    closeOthers: '关闭其它',
    closeAll: '关闭所有',
  },
  mBtn: {
    addSub: '新增子项',
    dictConfig: '字典配置',
    download: '下载',
  },
  theader: {
    measuringPoint: '测量点',
    name: '名称',
    realTimeValue: '实时值',
    unit: '单位',
    updateTime: '更新时间',
    createTime: '创建时间',
    storage: '存储(分)',
    alerts: '告警',
    operate: '操作',
    project: '项目',
    area: '区域',
    detailAddress: '详细地址',
    protocol: '协议',
    correspondenceAddress: '通讯地址',
    dataTimeout: '数据超时(分)',
    serialNumber: '序号',
    deviceId: '设备ID',
    gatewayId: '网关ID',
    gatewayName: '网关名称',
    serialPortAddress: '串口地址',
    modelId: '模型ID',
    creationTime: '创建时间',
    updater: '更新人',
    dataEncoding: '数据编码',
    fourShakeAttributes: '四摇属性',
    storage: '存储(分)',
    storageClass: '存储类别',
    alarmTime: '告警时间',
    recoveryTime: '恢复时间',
    alarmLevel: '告警等级',
    alarmContent: '告警内容',
    reportName: '报告名称',
    reportTime: '报表时间',
    equipmentFailureRate: '设备故障率',
    score: '评分',
    healthStatus: '健康状态',
    roleName: '角色名称',
    tenants: '所属租户',
    roleAliaes: '角色别名',
    roleSorting: '角色排序',
    institutionName: '机构名称',
    fullNameOfOrganization: '机构全称',
    institutionType: '机构类型',
    sorting: '排序',
    loginAccount: '登录账号',
    userName: '用户姓名',
    role: '所属角色',
    department: '所属部门',
    userPlatform: '用户平台',
    potitionType: '岗位类型',
    positionNo: '岗位编号',
    potitionTitle: '岗位名称',
    potitionSorting: '岗位排序',
    dictionaryNumber: '字典编号',
    dictionaryName: '字典名称',
    dictionarySorting: '字典排序',
    archive: '封存',
    menuName: '菜单名称',
    rutingAddress: '路由地址',
    menuIcon: '菜单图标',
    menuAliases: '菜单别名',
    menuNo: '菜单编号',
    menuSorting: '菜单排序',
    tenantId: '租户ID',
    tenantName: '租户名称',
    contact: '联系人',
    contactNumber: '联系电话',
    accountLimit: '账号额度',
    expirationTime: '过期时间',
    bindDomainName: '绑定域名',
    projectArea: '项目区域',
    reportAttributes: '四报属性',
    description: '描述',
    caculateFactor: '计算因子',
    dataInfo: '数据信息',
  }
};
